<template>
    <LayoutCookieConsentWrapper
        class="embed-youtube-url"
        type="video"
        disabledMessage="Accept cookies to watch this video."
        :disabledPoster="poster ?? fallbackPoster"
        @cookies-accepted="autoplay = true"
    >
        <EmbedYoutubeLazyLoad v-if="youtubeId" :idYoutube="youtubeId" :autoplay="autoplay" :poster="poster ?? fallbackPoster" class="w-full" contentful />
    </LayoutCookieConsentWrapper>
</template>

<script>
export default {
    name: 'EmbedYoutubeUrl',
    data () {
        return {
            autoplay: false,
        };
    },
    props: {
        url: {
            type: String,
            required: true
        },
        poster: {
            type: String,
            required: false,
        }
    },
    computed: {
        youtubeId() {
            return this.extractYoutubeId(this.url);
        },
        fallbackPoster () {
            const id = this.extractYoutubeId(this.url);
            if (id) return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
            return undefined;
        },
    },
    methods: {
        extractYoutubeId(url) {
            let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            let match = url.match(regExp);
            return (match && match[7].length === 11) ? match[7] : null;
        }
    },
};

</script>
